import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import TeamBox from './teamBox';
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/person02.png";

const about = () => (
  <div id="about">
    <div className="wrapper">
      <Title title="SOBRE MI" />
      <p className="font12">
      ¡Hola! Soy Mónica, una apasionada coordinadora de eventos.
      Con una sólida formación en Publicidad y una Maestría en Planeación Estratégica, disfruto transformar ideas en experiencias inolvidables. Para mí, un evento es como narrar una historia: tiene un principio, un clímax y un final feliz. Es el escenario perfecto donde los festejados y asistentes comparten emociones y vivencias únicas.
      </p>
      <Row>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person01} name="Mónica" job="" />
        </Col>
        <Col md={12} lg={8}>
          <TeamInfo />
        </Col>
      </Row>
    </div>
  </div>
);

export default about;
